module.exports = __webpack_public_path__ + "img/pager6img.64681ded.png";